import {
  actionTypes,
  userManagersRequestFailure,
  userManagersRequestSuccess,
  userOusRequestFailure,
  userOusRequestSuccess,
  usersAccountRequestFailure,
  usersAccountRequestSuccess,
  usersEntitlementRequestFailure,
  usersEntitlementRequestSuccess,
  usersRequestFailure,
  usersRequestSuccess,
} from './actions'

import {
  fetchUsersAccountRequest,
  fetchUsersEntitlementRequest,
  fetchUsersManagersService,
  fetchUsersOusServices,
  fetchUsersRequest,
} from './services'

import { ofType } from 'redux-observable'
import { of } from 'rxjs'
import { catchError, map, mergeMap } from 'rxjs/operators'

const fetchUsersRequestEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.USERS_REQUEST),
    mergeMap(() =>
      fetchUsersRequest().pipe(
        map((response: any) => usersRequestSuccess(response)),
        catchError((error: any) => of(usersRequestFailure(error)))
      )
    )
  )

const fetchUsersAccountRequestEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.USERS_ACCOUNT_REQUEST),
    mergeMap((action: any) =>
      fetchUsersAccountRequest(action.userCode).pipe(
        map((response: any) => usersAccountRequestSuccess(response)),
        catchError((error: any) => of(usersAccountRequestFailure(error)))
      )
    )
  )

const fetchUsersEntitlementRequestEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.USERS_ENTITLEMENT_REQUEST),
    mergeMap((action: any) =>
      fetchUsersEntitlementRequest(action.userId).pipe(
        map((response: any) => usersEntitlementRequestSuccess(response)),
        catchError((error: any) => of(usersEntitlementRequestFailure(error)))
      )
    )
  )

const fetchUserManagersRequestEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.GET_USER_MANAGERS),
    mergeMap((action: any) =>
      fetchUsersManagersService(action.payload).pipe(
        map((response: any) => userManagersRequestSuccess(response)),
        catchError((error: any) => of(userManagersRequestFailure(error)))
      )
    )
  )

const fetchUserOusRequestEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.GET_USER_OUS),
    mergeMap((action: any) =>
      fetchUsersOusServices(action.payload).pipe(
        map((response: any) => userOusRequestSuccess(response)),
        catchError((error: any) => of(userOusRequestFailure(error)))
      )
    )
  )

const epics = [
  fetchUsersRequestEpic,
  fetchUsersAccountRequestEpic,
  fetchUsersEntitlementRequestEpic,
  fetchUserOusRequestEpic,
  fetchUserManagersRequestEpic,
]

export default epics
